import type { FunctionComponent } from "react";
import Highlighter from "react-highlight-words";
import type { FormattedCustomerDetails } from "components/job/JobLayout/JobCustomerDetails/helpers";
import { HIGHLIGHT_PROPS } from "./constants";
import useCustomerCellProps from "./useCustomerCellProps";

export interface CustomerCellProps {
  customerDetails: FormattedCustomerDetails;
}

const CustomerCell: FunctionComponent<CustomerCellProps> = function ({
  customerDetails,
}) {
  const { searchWords, name, contact, address } =
    useCustomerCellProps(customerDetails);

  return (
    <div className="flex flex-col text-12-18">
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={name || ""}
        className="text-12-18-em"
      />
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={contact || ""}
      />
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={address || ""}
      />
    </div>
  );
};

export default CustomerCell;
